<ng-container *transloco="let t; prefix: 'experience'">
  <div class="experience-insiders">
    <ess-experience-insiders-gallery>
      <div #gallery class="experience-gallery">
        @for (insider of insiders; track insider) {
          <ng-container *ngTemplateOutlet="experienceTemplate; context: {insider: insider}" />
        }
      </div>
    </ess-experience-insiders-gallery>
    <div class="experience-list">
      @for (insider of insiders; track insider) {
        <ng-container *ngTemplateOutlet="experienceTemplate; context: {insider: insider}" />
      }
    </div>
  </div>
  <ng-template #experienceTemplate let-insider="insider">
    <section class="insider" data-cy="experience-style">
      <div>
        <h3 class="heading-s" data-cy="experience-list-title"
          ><strong>{{ t('theExperience') }}</strong></h3
        >
        <h4 class="heading-xl" data-cy="experience-list-content-title">{{ insider.title }}</h4>
        <p [innerHTML]="insider.description" class="innerHtml" data-cy="experience-list-content"></p>
      </div>
      <figure>
        @if (insider.image) {
          <img
            alt="{{ t('imageTitle', {title: insider.title}) }}"
            src="{{ insider.image | resizeImg: 907 : 621 }}"
            data-cy="experience-list-photo"
          />
        }
      </figure>
    </section>
  </ng-template>
</ng-container>
